import { TimeZoneDateFnsService } from 'app/core/services/time-zone-date-fns.service';
import { NotificationStatus } from 'app/shared/enums/notification-status.enum';
import { CustomDatePipe } from 'app/shared/pipes/custom-date.pipe';
import { ReadExportAllNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-export-all-notification.view-model';
import { buildNotificationCardTitle } from '../../build-notification-card-title';
import { ExportAllNotificationCardModel } from './export-all-notification-card.model';

export class ExportAllNotificationModelHelper {
  public static build(): ExportAllNotificationCardModel {
    const exportAllNotification = new ExportAllNotificationCardModel();
    return exportAllNotification;
  }

  public static fromViewModel(
    readExportAllNotificationViewModels: ReadExportAllNotificationViewModel[],
    customDatePipe: CustomDatePipe,
  ): Array<ExportAllNotificationCardModel> {
    const exportAllNotifications = new Array<ExportAllNotificationCardModel>();
    readExportAllNotificationViewModels.forEach((readExportAllNotificationViewModel) => {
      const exportAllNotification = this._createModel(readExportAllNotificationViewModel, customDatePipe);
      exportAllNotifications.push(exportAllNotification);
    });

    return exportAllNotifications;
  }

  public static fromViewModelSingle(
    readExportAllNotificationViewModel: ReadExportAllNotificationViewModel,
    customDatePipe: CustomDatePipe,
  ): ExportAllNotificationCardModel {
    return this._createModel(readExportAllNotificationViewModel, customDatePipe);
  }

  private static _createModel(
    readExportAllNotificationViewModel: ReadExportAllNotificationViewModel,
    customDatePipe: CustomDatePipe,
  ): ExportAllNotificationCardModel {
    const exportAllNotificationCard = new ExportAllNotificationCardModel();
    exportAllNotificationCard.colorClass = 'notification-green';
    exportAllNotificationCard.discriminator = readExportAllNotificationViewModel.discriminator;
    exportAllNotificationCard.notificationDate = TimeZoneDateFnsService.toLaboratoryTimeZone(
      readExportAllNotificationViewModel.notificationDate,
    );
    exportAllNotificationCard.readDate = TimeZoneDateFnsService.toLaboratoryTimeZone(readExportAllNotificationViewModel.readDate);
    exportAllNotificationCard.title = buildNotificationCardTitle(
      'Export intégral',
      readExportAllNotificationViewModel.notificationDate,
      customDatePipe,
    );

    exportAllNotificationCard.messageLine1 = `Export intégral`;

    exportAllNotificationCard.statusFailedFlag = readExportAllNotificationViewModel.status === NotificationStatus.Failed;
    exportAllNotificationCard.statusNothingToDoFlag = readExportAllNotificationViewModel.status === NotificationStatus.NothingToDo;
    exportAllNotificationCard.statusPendingFlag = readExportAllNotificationViewModel.status === NotificationStatus.Pending;
    exportAllNotificationCard.statusSucceedFlag = readExportAllNotificationViewModel.status === NotificationStatus.Succeed;

    exportAllNotificationCard.uuid = readExportAllNotificationViewModel.uuid;
    return exportAllNotificationCard;
  }
}
